<template>
  <v-container>
    <field-label label="CRITÉRIOS CLÍNICOS">
      <v-row dense class="mt-3">
        <v-col>
          <field-label label="SCORAD" class="fill-height d-flex flex-column">
            <span
              class="big-number mt-auto"
              :class="{
                'grey--text text-lighten-1': computedScorad === '?',
                'green--text': computedScorad < 25,
                'orange--text': computedScorad >= 25 && computedScorad < 50,
                'red--text': computedScorad >= 50,
              }"
              >{{ computedScorad }}</span
            >
          </field-label>
        </v-col>
        <v-col>
          <field-label label="IGA" v-if="!attendance.data.summarizedFlow">
            <span
              class="big-number"
              :class="{
                'big-number--negative': computedIga === 4,
                'orange--text': computedIga === 3,
                'grey--text text-lighten-1': computedIga === '?',
              }"
              >{{ computedIga }}</span
            >
          </field-label>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <field-label label="EASI" class="fill-height d-flex flex-column">
            <span
              class="big-number mt-auto"
              :class="{
                'grey--text text-lighten-1': computedEasi === '?',
                'big-number--negative': computedEasi > 9,
              }"
              >{{ computedEasi }}</span
            >
          </field-label>
        </v-col>
        <v-col>
          <field-label label="BSA">
            <span
              class="big-number"
              :class="{
                'big-number--negative': computedBsa === '+' || computedBsa > 9,
                'grey--text text-lighten-1': computedBsa === '?',
              }"
              >{{ computedBsa }}</span
            >
          </field-label>
        </v-col>
      </v-row>
    </field-label>
    <field-label label="CRITÉRIOS DE SINTOMAS" class="mt-6">
      <v-row dense class="mt-3">
        <v-col cols="6" v-if="pharmaceuticalDomainConfig.CUSTOMSUMMARIZEDFLOW !== ECustomSummmarizedflow.SANOFI">
          <field-label label="WI-NRS" class="fill-height d-flex flex-column">
            <span
              class="big-number mt-auto"
              :class="{
                'big-number--negative': computedWinrs > 2,
                'grey--text text-lighten-1': computedWinrs === '?',
              }"
              >{{ computedWinrs }}</span
            >
          </field-label>
        </v-col>
        <v-col cols="6">
          <field-label label="POEM">
            <span
              class="big-number mt-auto"
              :class="computedPoem === '?' ? 'grey--text' : 'big-number ' + poemSeverity.class"
              >{{ computedPoem }}</span
            >
          </field-label>
        </v-col>
        <v-col cols="6" v-if="!attendance.data.summarizedFlow">
          <field-label label="POEM" class="fill-height d-flex flex-column">
            <span
              class="big-number mt-auto"
              :class="computedPoem === '?' ? 'grey--text' : 'big-number ' + poemSeverity.class"
              >{{ computedPoem }}</span
            >
          </field-label>
        </v-col>
        <v-col cols="6" v-if="!attendance.data.summarizedFlow">
          <field-label label="Pt-IGA">
            <span
              class="big-number"
              :class="{
                'big-number--negative': computedPtiga === 4,
                'orange--text': computedPtiga === 3,
                'grey--text text-lighten-1': computedPtiga === '?',
              }"
              >{{ computedPtiga }}</span
            >
          </field-label>
        </v-col>
        <v-col cols="6">
          <field-label label="ADCT" class="fill-height d-flex flex-column">
            <span
              class="big-number mt-auto"
              :class="computedAdct === '?' ? 'grey--text' : 'big-number ' + adctSeverity.class"
              >{{ computedAdct }}</span
            >
          </field-label>
        </v-col>
      </v-row>
      <field-label label="Qualidade de vida" titleClass="text-h6" titleColorClass="grey--text text--darken-2">
        <v-row dense class="mt-1">
          <v-col>
            <field-label label="DLQI" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': computedDlqi > 9,
                  'grey--text text-lighten-1': computedDlqi === '?',
                }"
                >{{ computedDlqi }}</span
              >
            </field-label>
          </v-col>
        </v-row>
      </field-label>
    </field-label>
  </v-container>
</template>

<script>
import scoresMixin from '@/components/AttendanceForm/atopicdermatitis/mixins/atopicdermatitisScoresMixin'
import FieldLabel from '@/components/FieldLabel.vue'
import { ECustomSummmarizedflow } from '@/constants/customSummarizedFlow'
import { createNamespacedHelpers } from 'vuex'
import BaseSummary from '../../general/summary/BaseSummary.vue'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')
const { mapGetters: authGettersMap } = createNamespacedHelpers('auth')

export default {
  extends: BaseSummary,
  mixins: [scoresMixin],
  components: { FieldLabel },
  computed: {
    ...attendanceGettersMap(['attendance']),
    ...authGettersMap(['pharmaceuticalDomainConfig']),
    ECustomSummmarizedflow() {
      return ECustomSummmarizedflow
    },
  },
  methods: {
    getSummaryData() {
      return {
        scorad: { value: this.computedScorad ?? '', text: 'SCORAD' },
        iga: { value: this.computedIga ?? '', text: 'IGA' },
        easi: { value: this.computedEasi ?? '', text: 'EASI' },
        bsa: { value: this.computedBsa ?? '', text: 'BSA' },
        winrs: { value: this.computedWinrs ?? '', text: 'WI-NRS' },
        sono: { value: this.computedSono ?? '', text: 'SONO' },
        poem: { value: this.computedPoem ?? '', text: 'POEM' },
        ptiga: { value: this.computedPtiga ?? '', text: 'Pt-IGA' },
        adct: { value: this.computedAdct ?? '', text: 'ADCT' },
        dlqi: { value: this.computedDlqi ?? '', text: 'DLQI' },
      }
    },
  },
}
</script>

<style scoped>
.big-number {
  font-weight: medium;
  color: green;
  font-size: 2.5rem;
}
.big-number--negative {
  color: red;
}
</style>
